import "./notebook.scss";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import DateObject from "react-date-object"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { FaToEnDigits } from "../../utils/faToEnDigits";
import { GetNotes } from "../../services/noteBookService";
import { GetTodos } from "../../services/todoService";
import { GetCheques } from "../../services/chequeService";
import { GetDocuments } from "../../services/documentService";
import Tooltip from "../tooltip/tooltip";
import HeaderDate from "../headerDate/headerDate";
import Tab from "../tab/tab";
import Notes from "../notes/notes";
import Todos from "../todos/todos";
import Cheques from "../cheques/cheques";
import Documents from "../documents/documents";

export default function Notebook() {
  const [notes, setNotes] = useState([]);
  const [todos, setTodos] = useState([]);
  const [cheques, setCheques] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [currentDate, setCurrentDate] = useState(new DateObject({ calendar: persian, locale: persian_fa}));
  const date = FaToEnDigits(currentDate.format("YYYYMMDD"));
  
  useEffect(() => {
    getNotes();
    getTodos();
    getCheques();
    getDocuments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDate]);

  const getNotes = async () => {
    try {
      const response = await GetNotes(date);
      setNotes(response.notes);
    } catch (err) {
      toast.error(err.error, { toastId: "error" });
    }
  }

  const getTodos = async () => {
    try {
      const response = await GetTodos(date);
      setTodos(response.todos);
    } catch (err) {
      toast.error(err.error, { toastId: "error" });
    }
  }

  const getCheques = async () => {
    try {
      const response = await GetCheques(date);
      setCheques(response.cheques);
    } catch (err) {
      toast.error(err.error, { toastId: "error" });
    }
  }
  
  const getDocuments = async () => {
    try {
      const response = await GetDocuments(date);
      setDocuments(response.documents);
    } catch (err) {
      toast.error(err.error, { toastId: "error" });
    }
  }

  return (
    <div className="notebook">
      <div className="ribon">
        <Tooltip tip="یادداشت های مهمت رو اینجا ثبت کن که همیشه دم دستت باشن"  />
        دفتر یادداشت
      </div>
      <div className="content">
        <HeaderDate currentDate={currentDate} setCurrentDate={setCurrentDate}  />
        <Tab getCheques={getCheques} getTodos={getTodos} getNotes={getNotes} getDocuments={getDocuments} date={date} currentDate={currentDate} />
        <div className="contentText">
          {cheques.length > 0 && <Cheques cheques={cheques} onManipulation={getCheques} currentDate={currentDate} />}
          {todos.length > 0 && <Todos todos={todos} onManipulation={getTodos} currentDate={currentDate} />}
          {notes.length > 0 && <Notes notes={notes} onManipulation={getNotes} />}
          {documents.length > 0 && <Documents documents={documents} onManipulation={getDocuments} />}
        </div>
      </div>
    </div>
  );
}
